// Studby — central axios instance.
// Base URL comes from env (REACT_APP_BACKEND_URL). Adds the JWT bearer token
// (saved in localStorage) to every request automatically.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Attach the saved token on every outgoing request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("studly_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Convert FastAPI error payloads into a readable string.
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
